import {
    LIST_CUSTOMER_LOAN,
    SAVE_CUSTOMER_LOAN,
    STORE_CUSTOMER_LOAN,
} from '../../constants/loan';

export const saveCustomerLoan = (data,callback) => ({
    type: SAVE_CUSTOMER_LOAN,
    data,
    callback
})


export const listCustomerLoan = (data) => ({
    type: LIST_CUSTOMER_LOAN,
    data
})

export const storeCustomerLoan = (loanHistory) => ({
    type: STORE_CUSTOMER_LOAN,
    loanHistory
})
